import axios from "axios";
import { MODEL_BASEURL_V1 } from "../baseUrls";

const geojsonToFile = (geojson, filename) =>
  new File([JSON.stringify(geojson)], filename, {
    type: "application/geo+json",
  });
const REPORT_PATHS = {
  complete: "/reports/",
  impact: "/reports/impact",
  cost: "/reports/cost",
  preserve: "/reports/preserve",
  menace: "/reports/menace",
  sinistre: "/reports/sinistre",
};

class analysisModelAPI {
async postImpactsApi({ simulatedFire, realFire, reference, fireDate, severity }) {
  const formData = new FormData();
  formData.append(
    "simulated_fire",
    geojsonToFile(simulatedFire, "simulated_fire.geojson"),
  );
  formData.append("real_fire", geojsonToFile(realFire, "real_fire.geojson"));
  formData.append("reference", reference);
  formData.append("fire_date", fireDate);
  if (severity) formData.append("severity_index", severity);
  return axios.post(
    `${MODEL_BASEURL_V1}/fire-analysis/`,
    formData,
  );
}
  async postCostApi({ analysisId, ressources, unitValues }) {
    return axios.post(
      `${MODEL_BASEURL_V1}/fire-analysis/${analysisId}/money/`,
      { ressources, unit_values: unitValues },
    );
  }
  async postReportApi({ type, moneyId }) {
    return axios.post(
      `${MODEL_BASEURL_V1}${REPORT_PATHS[type]}`,
      { money_id: moneyId },
      { responseType: "blob" },
    );
  }
}

export default analysisModelAPI;
